import { Theme } from '@material-ui/core/styles/createTheme';
import { createTheme } from '@material-ui/core/styles';
import palette from 'assets/themes/Houston/palette';
import { enCourseTheme } from 'interface/customizations';
import typography from '../Houston/typography';

export interface ICourseTheme {
  background: string;
  text: string;
  cardBackground: string;
  categoryText: string;
  divider: string;
}

export type CourseTheme = Theme & {
  variables: {
    courseTheme: ICourseTheme;
  };
};

const black = createTheme({
  typography,
  spacing: 4,
  palette,
  variables: {
    courseTheme: {
      background: palette.neutrals.black,
      text: palette.common.white,
      cardBackground: palette.safevideo.dark,
      categoryText: palette.primary.light,
      divider: palette.grey[600],
    },
  } as any,
});

const white = createTheme({
  typography,
  spacing: 4,
  palette,
  variables: {
    courseTheme: {
      background: palette.common.white,
      text: palette.grey[600],
      cardBackground: palette.grey[200],
      categoryText: palette.grey[600],
      divider: palette.grey[300],
    },
  } as any,
});

const getCourseTheme = (theme: enCourseTheme = enCourseTheme.black) => {
  const mapper = {
    [enCourseTheme.black]: black,
    [enCourseTheme.white]: white,
  };
  return mapper[theme] ?? black;
};

export default getCourseTheme;
